import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { awardItems } from '@/mocks/certificateData';

export default function AwardItems() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('certificate.award.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {lang === 'en' ? t('certificate.award.title') : awardItems.title}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {awardItems.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[700px] mx-auto">
            {lang === 'en' ? t('certificate.award.lead') : awardItems.lead}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {awardItems.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100/60 border border-background-200/60 p-5 text-center"
            >
              <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 bg-accent-500/10 rounded-full">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              <h3 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
                {lang === 'en' ? t(`certificate.award.item.${idx}.name`) : item.name}
              </h3>
              <p className="text-[13px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {lang === 'en' ? t(`certificate.award.item.${idx}.desc`) : item.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-[13px] text-foreground-400 tracking-[0.04em] leading-relaxed mt-8">
          {lang === 'en' ? t('certificate.award.rosterNote') : awardItems.rosterNote}
        </p>
      </div>
    </section>
  );
}
